export const securisationTypes = ['LOI', 'BAIL'] as const
export type SecurisationType = (typeof securisationTypes)[number]

export const securisationTypeLabel: Record<SecurisationType, string> = {
  LOI: 'LOI',
  BAIL: 'Bail',
}
